import React from 'react'
import { Calendar } from 'primereact/calendar'
import { useTranslation } from 'react-i18next';
import { Checkbox } from 'primereact/checkbox';
import { classNames } from "primereact/utils";

export const StartDateCalender = (props) => {
    const { formik, business, checked, setChecked, getFormErrorMessage, isFormFieldValid, today, invalidDates } = props;

    const { t } = useTranslation("common");

    return (
        <>
            <div className="title flex">
                <p className="labels">{t("invitation.subscriber_start_date")}</p>
                <p className="isterik">*</p>
            </div>

            <div className="date-content">
                <div style={{ marginBottom: "0.3rem" }}>
                    <div className="calen-div">
                        <Calendar
                            id="startDate invite-calender"
                            name="startDate"
                            value={formik.values.startDate}
                            disabledDates={invalidDates}
                            minDate={today}
                            readOnlyInput
                            inputMode=""
                            dateFormat={business?.country?.jsShortDateFormat}
                            onChange={formik.handleChange} showIcon
                            placeholder={t("invitation.date_select")}
                            className="p-datepicker-header invite-calender datepicker"
                            disabled={checked}
                        />
                    </div>
                    <label
                        htmlFor="startDate"
                        className={classNames({
                            "p-error": isFormFieldValid("startDate"),
                        })}
                    ></label>
                </div>
                <div className="error-msg">{getFormErrorMessage("startDate")}</div>
            </div>
            <div className="flex">
                <Checkbox
                    id="check_box"
                    className="check"
                    inputId="binary"
                    checked={checked}
                    onChange={() => setChecked(!checked)}
                />
                <div className="checkedbox_div_label">{!checked ? <label className="unchecked_label">{t("invitation.date_checkbox")}</label> :
                    <label id="checkbox_title" htmlFor="binary">{t("invitation.date_checkbox")}</label>}
                </div>
            </div>
        </>
    )
}
